import {
  AccountingPaymentStatus,
  AccountingSubType,
} from "@entities/accounting/lib/constants";

export type InvoiceDocType = "All" | AccountingSubType;

export interface AccountingDateRange {
  from?: Date;
  to?: Date;
}

export interface InvoiceFiltersState {
  brandIds: { name: string; id: string }[];
  paymentStatuses: AccountingPaymentStatus[];
  briefIds: { name: string; id: string }[];
  accountingDate?: AccountingDateRange;
}

export const DOC_TYPE_OPTIONS: InvoiceDocType[] = [
  "All",
  AccountingSubType.invoice,
  AccountingSubType.creditNote,
  AccountingSubType.debitNote,
];

export const PAYMENT_STATUS_OPTIONS: {
  value: AccountingPaymentStatus;
  label: string;
}[] = [
  { value: AccountingPaymentStatus.paid, label: "Paid" },
  { value: AccountingPaymentStatus.partiallyPaid, label: "Partially Paid" },
  { value: AccountingPaymentStatus.pending, label: "Pending" },
  { value: AccountingPaymentStatus.cnIssued, label: "CN Issued" },
];

export interface FinanceInvoiceFiltersProps {
  searchQuery: string;
  setSearchQuery: (v: string) => void;
  docType: InvoiceDocType;
  setDocType: (v: InvoiceDocType) => void;
  filters: InvoiceFiltersState;
  setFilters: (
    f:
      | InvoiceFiltersState
      | ((prev: InvoiceFiltersState) => InvoiceFiltersState)
  ) => void;
  onExportCsv?: () => void;
  onAddBilling?: () => void;
  onAddCreditNote?: () => void;
  onDownloadBilling?: () => void;
}
